import { AppStartupService } from './app-startup';
import { Injectable, Inject } from '@angular/core';
import { HttpHeaders, HttpRequest, HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// Observable class extensions
// =====================================
import 'rxjs/add/observable/of';

// Observable operators
// =====================================
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/share';

import { IUrlOptions, RequestTypes } from '../models/rest.caller.model';
import { UIStorageService } from './storage.service';
import { LocalCacheService } from './cache/local-cache.service';
import { LoggingService } from './logging/logging.service';
import { LoggingConstants } from './../constants/logging-constant';
import { AppUtility } from './../utils/utility';
import { DomStorageFallbackService } from './DomStorageFallback.service';
import { LogFrontendError } from './logging/logFrontendError';
import {map } from 'rxjs/operators';

@Injectable()
export class RemoteService {
    // private static GatewayURL: string = '';
    private static attrsToStrip: string[] = ['technicalNameForLink', 'baseClntInd', 'baseClientIndicator', 'userFriendlyNameForLink', 'tileid', 'tileTechnicalName', 'isUCCELink', 'domain', '_3_struts_action', 'displayDocumentTypeFacetCL'];
    private static preAuthAllowedEndPointsList: string[] = ['channel/clientappconfigurations/upoint/pagelayout/pagename/home', 'channel/clientappconfigurations/upoint/pagelayout/pagename/login', 'channel/content/documentManagement/fileAttributes/get', 'channel/authentication/logon'];
    private renewSessionBufferCalls: any[] = [];
    private isEditPresent = false;
    private editsValue = '';
    private isSystemTicketPresent = false;
    private systemTicketValue = '';
    private strippedJson;
    private finalARH;
    public preauthServiceClientUrl: string = 'channel/clientappconfigurations/upoint/clientsetup/clientname/';

    /* istanbul ignore next */
    constructor( // @Inject('AuthHttp') private authHttp: AuthHttp,
        private storageService: UIStorageService,
        private localCacheService: LocalCacheService,
        private http: HttpClient,
        private appStartup: AppStartupService,
        private loggingService: LoggingService,
        private appUtility: AppUtility,
        private domStorageFB: DomStorageFallbackService,
        private logError: LogFrontendError
    ) {
    }

    // constructUrl is a helper function concating URL parameter
    /* istanbul ignore next */
    public constructUrl(urlOptions: IUrlOptions): string {
        if (urlOptions.endPoint.startsWith('http')) {
            return urlOptions.endPoint + urlOptions.restOfUrl;
        }
        // PCA-9538 changes starts
        // tslint:disable-next-line:max-line-length
        if ((this.domStorageFB.getItem('enableDynamicURL') === null || this.domStorageFB.getItem('enableDynamicURL') === 'null') || (this.domStorageFB.getItem('enableDynamicURL') === false || this.domStorageFB.getItem('enableDynamicURL') === 'false')) {
            if (LoggingService.uConsole) {
                console.log('gatewayUrlOverridden : constructUrl > enableDynamicURL = false');
            }
            // tslint:disable-next-line:max-line-length
            if (this.domStorageFB.getItem('gatewayUrl') && this.domStorageFB.getItem('gatewayUrl') !== '' && this.domStorageFB.getItem('gatewayUrl') !== null && this.domStorageFB.getItem('gatewayUrl') !== undefined) {
                if (LoggingService.uConsole) {
                    // tslint:disable-next-line:max-line-length
                    console.log('gatewayUrlOverridden : constructUrl > enableDynamicURL = false > gatewayUrl found in domStorage', this.domStorageFB.getItem('gatewayUrl') + urlOptions.endPoint + urlOptions.restOfUrl);
                }
                return this.domStorageFB.getItem('gatewayUrl') + urlOptions.endPoint + urlOptions.restOfUrl;
            } else {
                if (LoggingService.uConsole) {
                    // tslint:disable-next-line:max-line-length
                    console.log('gatewayUrlOverridden : constructUrl > enableDynamicURL = false > gatewayUrl not found in domStorage : appstartup.gateWayURL().. :', this.appStartup.gateWayURL() + urlOptions.endPoint + urlOptions.restOfUrl);
                }
                return this.appStartup.gateWayURL() + urlOptions.endPoint + urlOptions.restOfUrl;
            }
        } else {
            if (LoggingService.uConsole) {
                console.log('gatewayUrlOverridden : constructUrl > enableDynamicURL = true');
            }
            if (!this.domStorageFB.getItem('gatewayUrlOverridden')) {
                let newApiUrl = this.appUtility.getUpointNextUrl();
                newApiUrl = newApiUrl + '/alightapi/api/';
                if (LoggingService.uConsole) {
                    // tslint:disable-next-line:max-line-length
                    console.log('gatewayUrlOverridden : constructUrl > enableDynamicURL = true > gatewayUrlOverridden flag false :', newApiUrl + urlOptions.endPoint + urlOptions.restOfUrl);
                }
                return newApiUrl + urlOptions.endPoint + urlOptions.restOfUrl;
            } else {
                if (LoggingService.uConsole) {
                    // tslint:disable-next-line:max-line-length
                    console.log('gatewayUrlOverridden : constructUrl > enableDynamicURL = true > gatewayUrlOverridden flag true :', this.domStorageFB.getItem('gatewayUrl') + urlOptions.endPoint + urlOptions.restOfUrl);
                }
                return this.domStorageFB.getItem('gatewayUrl') + urlOptions.endPoint + urlOptions.restOfUrl;
            }
        }
    }

    /* istanbul ignore next */
    public constructHeader(urlOptions: IUrlOptions, header: HttpHeaders): HttpHeaders {
        const cHeader: any[] = urlOptions.customHeader;
        for (const aHeaderItem in cHeader) {
            if (aHeaderItem) {
                if ('customInstanceName' === cHeader[aHeaderItem].key) {
                    continue;
                }
                if (cHeader[aHeaderItem].key.toLowerCase() !== 'edithandlinginstructions' && cHeader[aHeaderItem].key.toLowerCase() !== 'systemtickets') {
                    header.append(cHeader[aHeaderItem].key, cHeader[aHeaderItem].value);
                }
                if ('edithandlinginstructions' === cHeader[aHeaderItem].key.toLowerCase()) {
                    this.isEditPresent = true;
                    this.editsValue = cHeader[aHeaderItem].value;
                }
                if ('systemtickets' === cHeader[aHeaderItem].key.toLowerCase()) {
                    this.isSystemTicketPresent = true;
                    this.systemTicketValue = cHeader[aHeaderItem].value;
                }
            }
        }
        let useSecondaryDataCache = this.domStorageFB.getItem('REDIS_INSTANCE_ALIAS');
        if (useSecondaryDataCache) {
            // header.append('UseSecondaryDataCache', 'true');
            header.append('SecondaryRedisAlias', useSecondaryDataCache);
        }
        return header;
    }
    /*
    commneted as its not being used any where, kept for temporary purpose , will be removed in next commit.
        public async ProvisionMockAHUser<T>(user: string) {
            let response = await this.http.post(
                this.appStartup.gateWayURL() + 'channel/authentication-dummy/person',
                {
                    'channelUserProfile': {
                        'firstName': 'Dummy',
                        'lastName': 'Auth',
                        'adminId': '1234',
                        'CSSO': 'CSSO123',
                        'adminUpdateAccess': 'updated',
                        'ecsAdmin': 'ECS1234'
                    },
                    'brokerUserId': 'portal',
                    'clientId': 'A1234',
                    'idMapping': '[{Test1},{Test2}]',
                    'systemInstanceId': 'aString',
                    'testCfg': '@@SB',
                    'subjectId': '123',
                    'subjectType': 'Test',
                    'systemDate': '2017-10-31',
                    'locale': 'en_US',
                    'roleId': 'E'
                }).toPromise();

            let data = response.json();
            // sessionStorage.setItem('lr_json_data', JSON.stringify(data.user));
            this.domStorageFB.setItem('alightSecureSessionToken', data.alightsecuresessiontoken, '', true);
            return;
        } */

    /* istanbul ignore next */
    public _window(): any {
        // return the native window obj
        return window;
    }

    /**
     * Single generic method to be called by ech module to call a REST service.
     */
    // T specifies a generic output of function
    /* istanbul ignore next */
    public request<T>(requestType: string, urlOptions: IUrlOptions, body?: any, key?: string, retry?: any, isFullResReqd?: boolean, responseType?: any, widgetName?: any): Observable<any> {
        // let response: Observable<Response>;
        let options: any = undefined;
        let requestTypeIndex = RequestTypes[requestType];
        let _headers = new HttpHeaders();
        let reqObservable: Observable<T>;
        let consumerRefIDValue: any;
        /*Deriving Instance Name */
        let instanceName: string = this.getInstanceNameFrmReq(urlOptions.endPoint);
        let preAuth = false;
        let startTimeReq = new Date().getTime();
        let requsetUrl = urlOptions.endPoint;
        let uniqURLId = '_reqUrl' + Math.random();
        let reqTrackingObj = { 'startTime': startTimeReq, 'id': uniqURLId, 'reqURL': requsetUrl };
        let requestTrackingList: any[] = [];
        let nonSWPage = false;
        /* istanbul ignore next */
        const swXHRTasks = () => {
            try {
                let swFeatureEnabledForPageName = this.appUtility.isSWFeatureEnabledForPageName(instanceName);
                let swPageName = this.appUtility.getPageNameFromURL();
                let swConf = this.appUtility.getSWConfFromStorage();
                if (swFeatureEnabledForPageName === true) {
                    if (LoggingService.uConsole) {
                        console.log('zone-swFeatureEnabledForPageName-true', swFeatureEnabledForPageName + 'instanceName ' + instanceName);
                    }
                    Object.keys(swConf).forEach((keyName) => {
                        if (keyName === swPageName) {
                            this.domStorageFB.setItem('isSwXHR', true);
                        }
                    });
                }
                for (let pageKey in swConf) {
                    // IF PAGE NAME = Key name then nonSWPage = false
                    if (swPageName === pageKey) {
                        if (LoggingService.uConsole) {
                            console.log('zone-nonSWPage-true-zero IF ==== SWpage Matched', nonSWPage + ' instanceName ' + instanceName);
                        }
                        nonSWPage = false;
                        break;
                    } else {
                        nonSWPage = true;
                        if (LoggingService.uConsole) {
                            console.log('zone-nonSWPage-true-zero ELSE ==== SWpage NOT Matched', nonSWPage + ' instanceName ' + instanceName);
                        }
                    }
                }
            } catch (e) {
                if (LoggingService.uConsole) {
                    console.log('AppUtility| isSwXHR - Error!!! - ', e);
                }
            }
        };
        swXHRTasks();
        // Added validation on alightRequestHeader/alightSecureSessionToken for checking invalid calls as per PCA-6837 .
        try {
            try {
                if (this.appUtility.isAfEnabled() && this.appUtility.isLiferay() === false && preAuth === false && instanceName && instanceName !== null && instanceName !== '' && this.appUtility.isSwFeatureEnabled()) {
                    if (this.domStorageFB.getItem('isSwXHR') === true || this.domStorageFB.getItem('isSwXHR') === 'true') {
                        if (!(this.domStorageFB.getItem('requestStartTime'))) {
                            if (LoggingService.uConsole) {
                                console.log('ZONE-setting requestStartTime', new Date().toUTCString());
                                console.log('ZONE-requsetUrl', urlOptions.endPoint);
                            }
                            this.domStorageFB.setItem('requestStartTime', new Date().getTime());
                        }
                    }
                    if (nonSWPage) {
                        if (LoggingService.uConsole) {
                            console.log('zone-nonSWPage-true-one', nonSWPage + 'instanceName ' + instanceName);
                        }
                        if (!(this.domStorageFB.getItem('requestStartTime'))) {
                            if (LoggingService.uConsole) {
                                console.log('ZONE-setting requestStartTime', new Date().toUTCString());
                                console.log('ZONE-requsetUrl', urlOptions.endPoint);
                            }
                            this.domStorageFB.setItem('requestStartTime', new Date().getTime());
                        }
                    }
                } else {
                    if (LoggingService.uConsole) {
                        console.log('zone-nonSWPage-true-two', nonSWPage + 'instanceName ' + instanceName);
                    }
                    if (!(this.domStorageFB.getItem('requestStartTime'))) {
                        if (LoggingService.uConsole) {
                            console.log('ZONE-setting requestStartTime', new Date().toUTCString());
                            console.log('ZONE-requsetUrl', urlOptions.endPoint);
                        }
                        this.domStorageFB.setItem('requestStartTime', new Date().getTime());
                    }
                }
            } catch (error) {
                if (LoggingService.uConsole) {
                    console.log('ZONE-Error getting requestStartTime ', error);
                }
            }
            try {
                if (urlOptions && urlOptions.customHeader) {
                    for (const aHeaderItem in urlOptions.customHeader) {
                        if (aHeaderItem) {
                            if ('customInstanceName' === urlOptions.customHeader[aHeaderItem].key) {
                                instanceName = urlOptions.customHeader[aHeaderItem].value;
                                break;
                            }
                        }
                    }
                }
            } catch (error) {
                if (LoggingService.uConsole) {
                    console.log('Error getting custom instance name ', error);
                }
            }
            let isChannelRequestData = false;
            let aSecureStValue = this.domStorageFB.getItem('alightSecureSessionToken', '', true);
            let aReqHeaderValue = this.domStorageFB.getItem('alightRequestHeader');

            // DCH-4028 : JD44955 - UPoint - Portal Support - UPN Ret Flow: Choose Payment Option page not showing all custom paragraphs
            // Allow Liferay to run clear cache if following cookie is available
            if (urlOptions.endPoint && urlOptions.endPoint.indexOf('/initwidget') !== -1) {
                this.domStorageFB.writeCookie('clearLRCache', true, true, false);
                this.domStorageFB.removeItem('alightInitConfig', 'sessionStorage');
            }

            // added preauthserviceclienturl in preAuthAllowedEndPointsList
            if (RemoteService.preAuthAllowedEndPointsList.indexOf(this.preauthServiceClientUrl) === -1) {
                this.preauthServiceClientUrl = this.preauthServiceClientUrl + this.getOrgName();
                RemoteService.preAuthAllowedEndPointsList.push(this.preauthServiceClientUrl);
            }
            // PreAuth Changes - Start
            if (urlOptions.endPoint.endsWith('/public') || RemoteService.preAuthAllowedEndPointsList.indexOf(urlOptions.endPoint) !== -1) {
                preAuth = true;
                // this.updateARHForPreAuth(); // Commented as clientID attribute logic is added in further processing, after confirmation can remove this code.
            }
            // PreAuth Changes - Ends
            if (!preAuth && (!(aSecureStValue) || (aSecureStValue === 'null') || (aSecureStValue.trim() === '') || (aSecureStValue === '""'))) {
                if (LoggingService.uConsole) {
                    console.log('RemoteService request method  :: Valid alightSecureSessionToken is missing in header. ', urlOptions);
                }
                // blank observable
                return new Observable((observer) => {
                    observer.next({
                        'msg': 'Valid alightSecureSessionToken is missing in header for ' + urlOptions.endPoint,
                        'text': '',
                        'headers': ''
                    });
                    observer.complete();
                });
            }


            // Added validation for checking channelRequestData in alightRequestHeader start here
            if (aReqHeaderValue) {
                isChannelRequestData = aReqHeaderValue.indexOf('channelRequestData') !== -1;
                if (LoggingService.uConsole) {
                    console.log('RemoteService request method isChannelRequestData in alightRequestHeader', isChannelRequestData);
                }
            }
            // validation for checking channelRequestData in alightRequestHeader ends here
            if (!(aReqHeaderValue) || (aReqHeaderValue === 'null') || (aReqHeaderValue.trim() === '') || (aReqHeaderValue === '""') || (isChannelRequestData === false)) {
                if (LoggingService.uConsole) {
                    console.log('RemoteService request method:: Valid alightRequestHeader is missing in header ', urlOptions);
                }
                return new Observable((observer) => {
                    observer.next({
                        'msg': 'Valid alightRequestHeader is missing in header for ' + urlOptions.endPoint,
                        'text': '',
                        'headers': ''
                    });
                    observer.complete();
                });
            }

            // check auth for pre or not PCA-8474
            if (preAuth) {
                if (this.domStorageFB.isValidToken(this.domStorageFB.getItem('alightTransmitSessionToken', '', true))) {
                    if (LoggingService.uConsole) {
                        console.log('*****alightTransmitSessionToken Found in the session Storage', this.domStorageFB.getItem('alightTransmitSessionToken'));
                    }
                    _headers = _headers.append('alightTransmitSessionToken', this.domStorageFB.getItem('alightTransmitSessionToken', '', true));
                } else {
                    if (LoggingService.uConsole) {
                        console.log('***** alightTransmitSessionToken Not Found in the session Storage');
                    }
                }
            }

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('RemoteService request method error while validating required headers:: ', error);
            }
        }

        if (LoggingService.uConsole) {
            console.log('RemoteService request headers value::', this.domStorageFB.getItem('alightRequestHeader'));
        }

        // Added validation on alightRequestHeader/alightSecureSessionToken for checking invalid calls as per PCA-6837 ends here.


        // SM02573
        try {

            if (!preAuth) {
                let ds = this._window().dateString;
                if (ds) {
                    if (LoggingService.uConsole) {
                        console.log('Date String found in window variable');
                    }
                } else {
                    ds = this.formatDate();
                }
                if (ds) {
                    let aRH = this.domStorageFB.getItem('alightRequestHeader');
                    if (LoggingService.uConsole) {
                        console.log('Date String', ds, aRH);
                    }

                    if (aRH) {
                        let aRHJson = JSON.parse(aRH);
                        let CRData = aRHJson.channelRequestData;
                        if (CRData) {
                            if (CRData.indexOf('::ds::') === -1) {
                                let newCRD = aRHJson.channelRequestData + 'ds::' + ds + '::';
                                let updatedARH = this.storageService.addAttributeToJsonObject('channelRequestData', newCRD, aRHJson);
                                this.domStorageFB.setItem('alightRequestHeader', JSON.stringify(updatedARH));
                            }
                        }
                    }
                }
            }

            // Add UxUniquePageId, PageName and DeviceType to channelRequestData
            this.appUtility.updateChannelRequestData({
                'uxPageRequestId': this.domStorageFB.getItem('uniquePageId', '', true),
                'pageName': this.appUtility.getPageNameFromURL(),
                'deviceType': this.domStorageFB.getItem('upointDeviceType', '', true),
                'sessionCreatedTimestamp': this.domStorageFB.getItem('sessionCreatedTimestamp', 'sessionStorage', true),
                'widgetName': widgetName || null
            });

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error adding Date String ', error);
            }
        }

        try {
            // Added support for alightPersonSessionToken ,PCA-6674
            if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true))) {
                if (LoggingService.uConsole) {
                    console.log('***** alightPersonSessionToken Found in the session Storage');
                }
                if (!(urlOptions.endPoint.endsWith('/public'))) {
                    _headers = _headers.append('alightPersonSessionToken', this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true));
                }
            } else if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true))) {
                if (LoggingService.uConsole) {
                    console.log('***** alightSecureSessionToken Found in the session Storage');
                }
                if (!(urlOptions.endPoint.endsWith('/public'))) {
                    _headers = _headers.append('alightSecureSessionToken', this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true));
                }
            }

            // Added support for alightPersonSessionToken ,PCA-6674 ends here
            if (LoggingService.uConsole) {
                console.log('RemoteService.request method  -alightSecureSessionToken value :: ', this.domStorageFB.getItem('alightSecureSessionToken', '', true));
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('RemoteService request method catch block :: ', error);
            }
            this.loggingService._debug('Error occurred while setting alightSecureSessionToken to header ', JSON.stringify(urlOptions), LoggingConstants.ERROR, error);
        }

        try {
            let uAgent = navigator.userAgent;
            let browserName = this.appUtility.getBrowser(uAgent);
            if (browserName !== '' && browserName === 'ie') {
                _headers = _headers.append('User-Agent', uAgent);
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('RemoteService request method catch block 1 :: ', error);
            }
        }

        try {
            let tempValue = JSON.parse(this.domStorageFB.getItem('alightRequestHeader'));
            tempValue = this.validateClientIdAttribute(tempValue); // Added for clientId attribute validation(Preauth/Postauth api call support)

            let updatedTempValue = this.storageService.addAttributeToJsonObject('consumerReferenceId', this.storageService.uuid(), tempValue);
            // Added  for adding clientId in aligthRequestHeader
            /* tslint:disable-next-line */
            let strippedTempValue = this.storageService.stripAttrFromJson(RemoteService.attrsToStrip, "channelRequestData", updatedTempValue);
            if (LoggingService.uConsole) {
                console.log('strippedTempValue before delete', strippedTempValue);
            }
            delete updatedTempValue['channelRequestData'];

            if (LoggingService.uConsole) {
                console.log('RemoteService strippedTempValue:: ', strippedTempValue);
            }
            if (strippedTempValue && strippedTempValue !== 'null' && strippedTempValue.indexOf(' Time - Other Resources - Year End Tax Forms') !== -1) {
                let strippedTempValueUpdated = strippedTempValue.replace(' Time - Other Resources - Year End Tax Forms', '');
                this.strippedJson = this.storageService.addAttributeToJsonObject('channelRequestData', strippedTempValueUpdated, updatedTempValue);
            } else {
                this.strippedJson = this.storageService.addAttributeToJsonObject('channelRequestData', strippedTempValue, updatedTempValue);
            }
            consumerRefIDValue = updatedTempValue.consumerReferenceId;

            this.finalARH = this.strippedJson;
            _headers = _headers.append('alightRequestHeader', JSON.stringify(this.finalARH));
            // For adding verbosity header with remote api call
            let verbosityQryParamValue = this.getUrlQueryParameter('verbosity');
            if (verbosityQryParamValue) {
                _headers = _headers.append('verbosity', verbosityQryParamValue);
            }
            // For adding verbosity header with remote api call ends here
            // Added cache control header for IE caching issues resolution.
            _headers = _headers.append('Cache-control', 'no-cache');
            _headers = _headers.append('Pragma', 'no-cache');

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('RemoteService request method catch block 2 :: ', error, ' _headers: ', _headers);
            }
            this.loggingService._debug('Error occurred while header creation for Remote api call ', JSON.stringify(urlOptions), LoggingConstants.ERROR, error);
        }

        _headers = this.constructHeader(urlOptions, _headers);
        // Added support for edits in request header
        try {
            this.finalARH = JSON.parse(_headers.get('alightRequestHeader'));
            if (this.isEditPresent) {
                this.finalARH = this.storageService.addAttributeToJsonObject('editHandlingInstructions', this.editsValue, JSON.parse(_headers.get('alightRequestHeader')));
                this.isEditPresent = false;
                this.editsValue = '';
            }
            if (_headers.has('alightRequestHeader')) {
                _headers = _headers.delete('alightRequestHeader');
                _headers = _headers.append('alightRequestHeader', JSON.stringify(this.finalARH));
            }
            if (this.isSystemTicketPresent) {
                this.finalARH = this.storageService.addAttributeToJsonObject('systemTickets', this.systemTicketValue, JSON.parse(_headers.get('alightRequestHeader')));
                this.isSystemTicketPresent = false;
                this.systemTicketValue = '';
            }
            if (_headers.has('alightRequestHeader')) {
                _headers = _headers.delete('alightRequestHeader');
                _headers = _headers.append('alightRequestHeader', JSON.stringify(this.finalARH));
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('RemoteService added support for edits in request header :: ', error);
            }
        }

        let swEnableFlag: boolean = false;
        // UFD-1558
        try {
            if (this.appUtility.isAfEnabled() && this.appUtility.isLiferay() === false && preAuth === false && instanceName && instanceName !== null && instanceName !== '' && this.appUtility.isSwFeatureEnabled()) {
                if (this.appUtility.isSWFeatureEnabledForPageName(instanceName)) {
                    if (LoggingService.uConsole) {
                        console.log('RemoteService | request() | Disable caching for ' + instanceName);
                    }
                    swEnableFlag = true;
                    _headers = _headers.append('swkey', key);
                    _headers = _headers.append('swPostLoginFlag', 'cache');
                    let userSwKey = this.domStorageFB.getItem('swUdIndexKey');
                    let buildNumber = undefined;
                    let orgName = this.appUtility.getOrgName().toLowerCase(); // UFD-3872
                    let app_url = this.domStorageFB.getItem('app_url');
                    if (app_url) {
                        let buildNumberIndex = app_url.substring(0, app_url.length - 1).lastIndexOf('/');
                        buildNumber = app_url.substring(buildNumberIndex + 1, app_url.length - 1);
                    }
                    // set to null to skip default processing.
                    key = null;
                    let userDataKeyString = null;
                    if (this.finalARH['roleId']) {
                        let locale = this.appUtility.getLocaleValue();
                        if (locale) {
                            if (userSwKey) {
                                userDataKeyString = orgName + '__' + this.finalARH['roleId'] + '__' + locale + '__' + userSwKey;
                            } else {
                                userDataKeyString = orgName + '__' + this.finalARH['roleId'] + '__' + locale;
                            }
                        } else {
                            userDataKeyString = orgName + '__' + this.finalARH['roleId'];
                        }
                        if (buildNumber) {
                            userDataKeyString = userDataKeyString + '__' + buildNumber;
                        }
                    }
                    if (userDataKeyString) {
                        _headers = _headers.append('swdatakey', userDataKeyString);
                    }
                    // added below falg for backward compatibility in PI data separation logic (SW.js - LiferaySide)
                    if (instanceName === 'tiles') {
                        _headers = _headers.append('swtilesavestructureflag', 'true');
                    }
                }
            }
        } catch (swError) {
            if (LoggingService.uConsole) {
                console.log('Error!!! RemoteService | request() |  ', swError);
            }
        }
        // Added for log tracing of remote service call through Application start here.
        // console.log('******before remote call usage log send**********************');
        // Added for log tracing of remote service call through Application start here.
        // console.log('******before remote call usage log send**********************');
        this.loggingService._usage(LoggingConstants.LOG_REMOTE_CALL_MSG, urlOptions.endPoint, '', LoggingConstants.LOG_USER_ACTION_CONSTANT_VALUE, LoggingConstants.GLOBAL_USAGE_LEVEL_SEVERITY, requestType, consumerRefIDValue);
        // True in case of urlOptions are available and urlOptions.isSecure is true
        /* istanbul ignore else */
        if (urlOptions && urlOptions.isSecure) {
            // Added condition for handling of multipart requests automatically from browser itself.
            if (urlOptions.contentType && (urlOptions.contentType !== 'null') && (urlOptions.contentType !== '') && (urlOptions.contentType.indexOf('multipart') === -1)) {
                _headers = _headers.append('Content-Type', urlOptions.contentType);

                if (urlOptions.customHeader) {
                    for (let i = 0; i < urlOptions.customHeader.length; i++) {
                        let obj = urlOptions.customHeader[i];
                        if (obj.key.toLowerCase() !== 'edithandlinginstructions' && obj.key.toLowerCase() !== 'systemtickets') {
                            _headers = _headers.append(obj.key, obj.value);
                        }
                    }
                }

            }
            if (responseType && responseType !== 'null' && responseType !== null && responseType !== '' && responseType !== undefined) {
                options = { headers: _headers, responseType: responseType, observe: 'response' };
            } else {
                options = { headers: _headers, observe: 'response' };
            }
        }

        // True in case of post, put and patch
        if (body && options) {
            /*Passing AuthHTTP Observable through Cache Function */
            reqObservable = this.http[RequestTypes[requestTypeIndex]](this.constructUrl(urlOptions), body, options)
            .pipe(map((res) => {
                if (isFullResReqd) {
                    this.domStorageFB.setItem('requestEndTime', new Date().getTime());
                    (<any>res)._body = (<any>res).body;
                    return res;
                } else {
                    this.domStorageFB.setItem('requestEndTime', new Date().getTime());
                    let obj = res ? res['body'] : null;
                    if (obj && typeof res['body'] === 'string') {
                        console.log('createLrAhUser res = string');
                        obj = res['body'];
                    } else {
                        obj['_body'] = JSON.stringify(res['body']);
                    }
                   return obj;
                }
            }))
                // .map((res) => <T>res.json())
                .catch(err => {
                    return this.handleError(err, requestType, urlOptions, body, key, this, consumerRefIDValue, retry);
                });
                return this.returnCachedObservable(key, reqObservable, instanceName, requestTypeIndex, urlOptions, options, isFullResReqd, swEnableFlag);


        } else if (body) {
            // True in case of post, put and patch if options is empty
            /* istanbul ignore next */
            reqObservable = this.http[RequestTypes[requestTypeIndex]](this.constructUrl(urlOptions), body)
            .pipe(map((res) => {
                if (isFullResReqd) {
                    this.domStorageFB.setItem('requestEndTime', new Date().getTime());
                    (<any>res)._body = (<any>res).body;
                    return res;
                } else {
                    this.domStorageFB.setItem('requestEndTime', new Date().getTime());
                    let obj = res ? res['body'] : null;
                    if (obj && typeof res['body'] === 'string') {
                        console.log('createLrAhUser res = string');
                        obj = res['body'];
                    } else {
                        obj['_body'] = JSON.stringify(res['body']);
                    }
                   return obj;
                }
            }))
                .catch(err => { return this.handleError(err, requestType, urlOptions, body, key, this, consumerRefIDValue, retry); });
                return this.returnCachedObservable(key, reqObservable, instanceName, requestTypeIndex, urlOptions, options, isFullResReqd, swEnableFlag);

        } else if (options) {
            // True in case of get, delete, head and options

            if (urlOptions.customHeader) {
                for (let i = 0; i < urlOptions.customHeader.length; i++) {
                    let obj = urlOptions.customHeader[i];
                    obj.value = obj.value ? obj.value : '';
                }
            }

            if (options.headers.lazyUpdate) {
                for (let i = 0; i < options.headers.lazyUpdate.length; i++) {
                    let obj = options.headers.lazyUpdate[i];
                    obj.value = obj.value ? obj.value : '';
                }
            }

            reqObservable = this.http[RequestTypes[requestTypeIndex]](this.constructUrl(urlOptions), options)
            .pipe(map(
                (res) => {
                    if (isFullResReqd) {
                        this.domStorageFB.setItem('requestEndTime', new Date().getTime());
                        (<any>res)._body = (<any>res).body;
                        return res;
                    } else {
                        this.domStorageFB.setItem('requestEndTime', new Date().getTime());
                        let obj = res ? res['body'] : null;
                        if (obj && typeof res['body'] === 'string') {
                            console.log('createLrAhUser res = string');
                            obj = res['body'];
                        } else {
                            obj['_body'] = JSON.stringify(res['body']);
                        }
                       return obj;
                    }
                },
                error => {
                    return this.handleError(error, requestType, urlOptions, body, key, this, consumerRefIDValue, retry);
                }
            ));

            return this.returnCachedObservable(key, reqObservable, instanceName, requestTypeIndex, urlOptions, options, isFullResReqd, swEnableFlag);

        }
    }

    /* istanbul ignore next */
    public renewSessionRetry(requestType?: string, urlOptions?: IUrlOptions, body?: any, key?: string) {
        if (LoggingService.uConsole) {
            console.log('RemoteService.renewSession Retry method Starting renew session process :: ');
        }

        // PCA-8799
        let endPointValue;
        let isSessionAPIEnabled = this.domStorageFB.getItem('enableSessionAPI', '', true);
        if (isSessionAPIEnabled && isSessionAPIEnabled === 'true') {
            endPointValue = 'session/renewSession';
        } else {
            endPointValue = 'renewSession';
        }

        this.request('post', {
            restOfUrl: '',
            endPoint: endPointValue,
            isSecure: true,
            contentType: 'application/json'
        }, { 'renewSession': 'true' }, null, true)
            .subscribe(
                data => {
                    if (LoggingService.uConsole) {
                        console.log('RemoteService.renewSession received response :: ', data, ' Token Received', data.text());

                    }

                    // let tempToken = data.text();
                    let tempToken;
                    let respHeaders = data.headers;


                    if (respHeaders) {
                        try {

                            tempToken = respHeaders.get('alightSecureSessionToken');
                            if (!tempToken || tempToken === 'null') {
                                tempToken = respHeaders.get('alightPersonSessionToken');

                                if (LoggingService.uConsole) {
                                    console.log('Remote.service.renewSessionRetry ::alightPersonSessionToken from Response.headers :: Token received - ', tempToken);
                                }
                            }

                            if (tempToken) {
                                if (LoggingService.uConsole) {
                                    console.log('Setting alightSecureSessionToken from Response.headers :: ', data, 'Token received - ', tempToken);
                                }
                            } else {
                                tempToken = data.text();
                                if (LoggingService.uConsole) {
                                    console.log('Setting alightSecureSessionToken from Response.data :: ', data, 'Token received - ', tempToken);
                                }
                            }
                        } catch (e) {
                            tempToken = data.text();
                            if (LoggingService.uConsole) {
                                console.log('Setting alightSecureSessionToken from Response.data :: ', data, 'Token received - ', tempToken);
                            }
                        }
                    } else {
                        tempToken = data.text();
                        if (LoggingService.uConsole) {
                            console.log('Setting alightSecureSessionToken from Response.data :: ', data, 'Token received - ', tempToken);
                        }
                    }

                    if (tempToken) {
                        if (this.domStorageFB.getItem('alightPersonSessionToken') && this.domStorageFB.getItem('alightPersonSessionToken') !== 'null') {
                            this.domStorageFB.setItem('alightPersonSessionToken', tempToken, '', true);
                            if (LoggingService.uConsole) {
                                console.log('Remote.service.renewSessionRetry :: Setting alightPersonSessionToken in storage  :: Token received - ', tempToken);
                            }
                        } else {
                            this.domStorageFB.setItem('alightSecureSessionToken', tempToken, '', true);
                            if (LoggingService.uConsole) {
                                console.log('Remote.service.renewSessionRetry :: Setting alightSecureSessionToken in storage  :: Token received - ', tempToken);
                            }
                        }
                    }
                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                },
                error => {

                    if (LoggingService.uConsole) {
                        console.log('RemoteService.renewSession retry error occurred :: ');
                    }

                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                },
                () => {

                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                }
            );


    }

    /**
     * Method to call renew session api
     */

    /* istanbul ignore next */
    public renewSession(requestType?: string, urlOptions?: IUrlOptions, body?: any, key?: string) {

        if (LoggingService.uConsole) {
            console.log('RemoteService.renewSession method Starting renew session process :: ');
        }

        // PCA-8799
        let endPointValue;
        let isSessionAPIEnabled = this.domStorageFB.getItem('enableSessionAPI', '', true);
        if (isSessionAPIEnabled && isSessionAPIEnabled === 'true') {
            endPointValue = 'session/renewSession';
        } else {
            endPointValue = 'renewSession';
        }

        this.request('post', {
            restOfUrl: '',
            endPoint: endPointValue,
            isSecure: true,
            contentType: 'application/json'
        }, { 'renewSession': 'true' }, null, true, true)
            .subscribe(
                data => {

                    if (LoggingService.uConsole) {
                        console.log('RemoteService.renewSession received response :: ', data, 'Token received - ', data.headers.get('alightSecureSessionToken') || data);

                    }

                    // let tempToken = data.headers.get('alightSecureSessionToken') || data.text();
                    let tempToken;
                    let respHeaders = data.headers;

                    if (respHeaders) {
                        try {
                            tempToken = respHeaders.get('alightSecureSessionToken');
                            if (!tempToken || tempToken === 'null') {
                                tempToken = respHeaders.get('alightPersonSessionToken');

                                if (LoggingService.uConsole) {
                                    console.log('Remote.service.renewSession ::alightPersonSessionToken from Response.headers :: Token received - ', tempToken);
                                }

                            }
                            if (tempToken) {
                                if (LoggingService.uConsole) {
                                    console.log('Setting alightSecureSessionToken from Response.headers :: ', data, 'Token received - ', tempToken);
                                }
                            } else {
                                tempToken = data.text();
                                if (LoggingService.uConsole) {
                                    console.log('Setting alightSecureSessionToken from Response.data :: ', data, 'Token received - ', tempToken);
                                }
                            }
                        } catch (e) {
                            tempToken = data.text();
                            if (LoggingService.uConsole) {
                                console.log('Setting alightSecureSessionToken from Response.data in catch :: ', data, 'Token received - ', tempToken);
                            }
                        }
                    } else {
                        tempToken = data.text();
                        if (LoggingService.uConsole) {
                            console.log('Setting alightSecureSessionToken from Response.data :: ', data, 'Token received - ', tempToken);
                        }
                    }

                    if (tempToken) {
                        if (this.domStorageFB.getItem('alightPersonSessionToken') && this.domStorageFB.getItem('alightPersonSessionToken') !== 'null') {
                            this.domStorageFB.setItem('alightPersonSessionToken', tempToken, '', true);
                            if (LoggingService.uConsole) {
                                console.log('Remote.service.renewSession :: Setting alightPersonSessionToken in storage  :: Token received - ', tempToken);
                            }
                        } else {
                            this.domStorageFB.setItem('alightSecureSessionToken', tempToken, '', true);
                            if (LoggingService.uConsole) {
                                console.log('Remote.service.renewSession:: Setting alightSecureSessionToken in storage  :: Token received - ', tempToken);
                            }
                        }
                    }
                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);

                },
                error => {


                    if (LoggingService.uConsole) {
                        console.log('RemoteService.renewSession error occurred. Retrying it... ');
                    }
                    this.renewSessionRetry();
                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                },
                () => {

                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                }
            );

    }

    /* istanbul ignore next */
    /* tslint:disable-next-line */
    private processBufferedCalls(requestType: string, urlOptions: IUrlOptions, body?: any, key?: string) {
        this.renewSessionBufferCalls.forEach((aCall: {
            requestType: string,
            urlOptions: IUrlOptions,
            body: any,
            key: any
        }) => {
            this.request(aCall.requestType, aCall.urlOptions, aCall.body, aCall.key);
        });
        this.renewSessionBufferCalls = [];
    }

    /* istanbul ignore next */
    private handleError(error: Response | any, requestType: string, urlOptions: IUrlOptions, body?: any, key?: string, docObjectRef?: Object, consumerRefIDValue?: string, retry?: any) {

        try {
            this.logError.setErrorDataToIDB(error, requestType, urlOptions, body, key, consumerRefIDValue);
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('RemoteService.handleError :: setErrorDataToIDB error : ', error);
            }
        }

        if (LoggingService.uConsole) {
            console.log('RemoteService.handleError :: error : ', error, ' requestType: ', requestType, ' urlOptions: ', urlOptions);

        }

        try {
            // Added for log tracing of http services in case of error occurred, through Application start here.
            if (error.message) {
                docObjectRef['loggingService']._usage(LoggingConstants.LOG_REMOTE_CALL_ERROR_MSG + ' ' + JSON.stringify(urlOptions), urlOptions.endPoint, error.message, '', LoggingConstants.GLOBAL_USAGE_LEVEL_SEVERITY, requestType, consumerRefIDValue);
            } else {
                docObjectRef['loggingService']._usage(LoggingConstants.LOG_REMOTE_CALL_ERROR_MSG + ' ' + JSON.stringify(urlOptions), urlOptions.endPoint, '', '', LoggingConstants.GLOBAL_USAGE_LEVEL_SEVERITY, requestType, consumerRefIDValue);
            }
            // Added for deleting Indexed db key in case of error response , so that there wont be saved error response in Indexed DB against key.
            if (key) {
                // After a certain time out key would be deleted from indexed db so that there won't be error of no store availability.
                setTimeout(function () {
                    docObjectRef['localCacheService'].removeItemFromIDBStorage(key, urlOptions.endPoint)
                        .subscribe((res: Response) => {
                            /* if (console) {
                                console.log('Successfully Key (' + key + ') deleted from IndexedDB ', res);
                            } */
                        }, err => {
                            /* if (console) {
                                console.log('Error while deleting key from Indexed DB', err);
                            } */
                        });
                }, 300);
            }

            // On Transaction page by default retry will be blocked
            // If user needs to retry service call on Transaction page then pass value as false for retry parameter
            if (window['isTransactionPage'] && (typeof retry === 'undefined' || retry === 'undefined')) {
                retry = true;
            }

            if (retry !== true) {
                if (requestType && requestType.toLowerCase() === 'get') {
                    if (LoggingService.uConsole) {
                        console.log('RemoteService retrying for GET requests: ', error, ' requestType: ', requestType, ' urlOptions: ', urlOptions);
                    }

                    if (error.status === 401) {
                        // 401 : Renew Session and retry the service call
                        let sessionRenewInProgress = this.domStorageFB.getItem('sessionRenewInProgress', '', true);
                        if (sessionRenewInProgress === 'false') {
                            this.renewSession(requestType, urlOptions, body, key);
                            this.domStorageFB.setItem('sessionRenewInProgress', 'true', '', true);
                            setTimeout(() => {
                                this.request(requestType, urlOptions, body, key, true);
                            }, 2000);
                        }
                    } else if (error.status === 500) {
                        if (error.message.indexOf('Timeoutexception') !== -1) {
                            // 500 and Timeout exception: Do not retry within the same session
                            this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue, 'debug');
                            return Observable.throw(error);
                        } else if (error.message.indexOf('service unavailable') !== -1) {
                            // 500 and service unavailable : Retry once and log retry
                            if (LoggingService.uConsole) {
                                console.log('RemoteService retrying for GET requests: ', error, ' requestType: ', requestType, ' urlOptions: ', urlOptions);
                            }
                            this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue, 'debug');
                            setTimeout(() => {
                                this.request(requestType, urlOptions, body, key, true);
                            }, 1000);
                        } else {
                            this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue);
                            return Observable.throw(error);
                        }
                    } else if (error.status === 400 || error.status === 404) {
                        if (LoggingService.uConsole) {
                            console.log('RemoteService retrying for GET requests: ', error, ' requestType: ', requestType, ' urlOptions: ', urlOptions);
                        }
                        this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue, 'debug');
                        setTimeout(() => {
                            this.request(requestType, urlOptions, body, key, true);
                        }, 1000);
                    } else {
                        this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue);
                        return Observable.throw(error);
                    }
                } else {
                    this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue);
                    return Observable.throw(error);
                }
            } else {
                if (LoggingService.uConsole) {
                    console.log('RemoteService retry failed for request. :: error : ', error, ' requestType: ', requestType, ' urlOptions: ', urlOptions);
                }

                if (error.status === 404) {
                    // Redirect to Liferay 404 page
                    this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue);
                    return Observable.throw(error);

                } else if (error.status === 500 || error.status === 400 || error.status === 401) {
                    this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue);
                    return Observable.throw(error);
                } else {
                    this.logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue);
                    return Observable.throw(error);
                }

            }
        } catch (error) {
            return Observable.throw(error);
        }

    }

    /* istanbul ignore next */
    private logServiceErrors(docObjectRef, error, requestType, urlOptions, consumerRefIDValue, errorType?: string) {
        // Added for log tracing of http services in case of error occurred, through Application start here.
        if (error.message) {
            docObjectRef['loggingService']._error(error.message + ' ' + JSON.stringify(urlOptions), urlOptions.endPoint, error.message, '', LoggingConstants.GLOBAL_USAGE_LEVEL_SEVERITY, requestType, consumerRefIDValue);
        } else {
            docObjectRef['loggingService']._usage(LoggingConstants.LOG_REMOTE_CALL_ERROR_MSG + ' ' + JSON.stringify(urlOptions), urlOptions.endPoint, '', '', LoggingConstants.GLOBAL_USAGE_LEVEL_SEVERITY, requestType, consumerRefIDValue);
        }
        if (errorType) {
            if (errorType === 'debug') {
                docObjectRef['loggingService']._debug(error.message + ' ' + JSON.stringify(urlOptions), urlOptions.endPoint, '', '', LoggingConstants.GLOBAL_USAGE_LEVEL_SEVERITY, requestType, consumerRefIDValue);
            }
        }

    }

    /*Pass Observable through Cache Service :Parth G */
    /* istanbul ignore next */
    private returnCachedObservable(key: string, observable: Observable<any>, instanceName: string, requestTypeIndex: any, urlOptions: IUrlOptions, options: any, isFullResReqd?: boolean, swEnableFlag?: boolean): Observable<any> {
        let refreshObservable: Observable<any>;
        if (LoggingService.uConsole) {
            console.log('RemoteService.returnCachedObservable0 method  Indexed db is enabled at browser :: ', LoggingConstants.IS_IDB_ENABLED_IN_BROWSER);
        }
        if (key === null || key === 'undefined' || key === undefined || key === '' || !(LoggingConstants.IS_IDB_ENABLED_IN_BROWSER)) {
            if (LoggingService.uConsole) {
                console.log('RemoteService.returnCachedObservable0 key is null for ', instanceName);
            }
            if (swEnableFlag) {
                if (LoggingService.uConsole) {
                    console.log('RemoteService.returnCachedObservable0 key is null and SW ', instanceName, swEnableFlag);
                }
                let tileGrpName = '';
                try {
                    if ('tiles' === instanceName) {
                        tileGrpName = urlOptions.customHeader[0].value;
                    }
                } catch (err) {
                    if (LoggingService.uConsole) {
                        console.log('RemoteService.returnCachedObservable2 method  Error while retrieving tileGroupName for SW flow - ', err);
                    }
                }
                refreshObservable = new Observable((observer) => {
                    observable.subscribe((data) => {
                        this.appUtility.storePIDataIntoSessionStorage(tileGrpName, data, instanceName); // executes only for Tiles
                        observer.next(data);
                        if (this.isDataExpired(data)) {
                            setTimeout(() => {
                                if (LoggingService.uConsole) {
                                    console.log('RemoteService | returnCachedObservable | triggering second call component=' + instanceName);
                                }
                                let _headers = new HttpHeaders();
                                _headers = options.headers;
                                if (_headers.has('swPostLoginFlag')) {
                                    _headers = _headers.delete('swPostLoginFlag');
                                    _headers = _headers.append('swPostLoginFlag', 'fresh');
                                }
                                options.headers = _headers;
                                this.http[RequestTypes[requestTypeIndex]](this.constructUrl(urlOptions), options).pipe(map((res) => {
                                    if (isFullResReqd) {
                                        if (res) {
                                            (<any>res)._body = (<any>res).body;
                                        }
                                        return res;
                                    } else {

                                        let obj = res ? res['body'] : null;
                                        if (obj && typeof res['body'] === 'string') {
                                            obj = res['body'];
                                        } else {
                                            obj['_body'] = JSON.stringify(res['body']);
                                        }
                                        return obj;
                                    }
                                })).subscribe((res2) => {
                                    try {
                                        if (!isFullResReqd && res2 && Object.prototype.toString.call(res2) === '[object Array]') {
                                            res2[0]['swcall'] = 'fresh';

                                        } else if (!isFullResReqd && res2 && Object.prototype.toString.call(res2) === '[object Object]') {
                                            res2['swcall'] = 'fresh';
                                        }
                                    } catch (errRes2) {
                                        if (LoggingService.uConsole) {
                                            console.log('RemoteService.returnCachedObservable2 method  Error!!! - ', errRes2);
                                        }
                                    }
                                    this.appUtility.storePIDataIntoSessionStorage(tileGrpName, res2, instanceName); // exectes only for Tiles
                                    observer.next(res2);
                                });
                            }, 100);
                        }
                    });
                });
                return refreshObservable;
            } else {
                return observable;
            }
        } else {
            return this.localCacheService.customObservable(key, observable, instanceName);
        }
    }

       /*
       validate expirytime from the data returned from SW cache
   */
    /* istanbul ignore next */
    isDataExpired(data: string) {
        try {
            if (data) {
                // data = JSON.parse(data);
                if (Object.prototype.toString.call(data) === '[object Array]') {
                    let expirytime = data[0]['expiryTime'];
                    if (expirytime) {
                        if (new Date(expirytime).getTime() > Date.now()) {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else if (Object.prototype.toString.call(data) === '[object Object]') {
                    let expirytime = data['expiryTime'];
                    if (expirytime) {
                        if (new Date(expirytime).getTime() > Date.now()) {
                            return false;
                        }
                    } else {
                        return false;
                    }
                }
            }
            return true;
        } catch (err) {
            if (LoggingService.uConsole) {
                console.log('Exception in checking expirytime in isDataExpired method with message = ' + err);
            }
            return true;
        }
    }


    /*
        GEt instance Name From Req : Parth G
    */
    /* istanbul ignore next */
    public getInstanceNameFrmReq(endPoint: string): string {
        let breakedEndPoint = endPoint.split('/');
        let temp = breakedEndPoint.pop();
        if (temp.indexOf('?') !== -1) {
            return temp.substring(0, temp.indexOf('?'));
        } else {
            return temp;
        }
    }

    /*Overloaded get method  : Parth G */
    /* istanbul ignore next */
    public getRequest(urlOptions: IUrlOptions, key?: string) {
        return this.request('get', urlOptions, null, key);
    }

    /**
     * Get the value of a querystring from URL
     * @param  {String} queryParamKey The field or key to get the value of
     */
    /* istanbul ignore next */
    public getUrlQueryParameter(queryParamKey: string) {
        let name = queryParamKey.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'),
            regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            queryParamValue = regex.exec(location.search);

        return queryParamValue === null ? '' : decodeURIComponent(queryParamValue[1].replace(/\+/g, ' '));
    }


    /**
     * Function for clearing all Indexed DB Stores.
     *  Clearing cache purpose.
     */
    /* istanbul ignore next */
    public clearAll_IDBStores() {
        this.localCacheService.clear_ALLIDBStores();
    }

    /**
     * Function for updating alightRequestHeader with clientId.
     * PreAuth Flow
     */
    /* istanbul ignore next */
    /* tslint:disable-next-line */
    private updateARHForPreAuth() {
        let aRHeader = this.domStorageFB.getItem('alightRequestHeader');
        if (aRHeader) {
            let aRHeaderJson = JSON.parse(aRHeader);
            let clientId = JSON.parse(this.domStorageFB.getItem('lr_json_data')).clientid.toString();
            let updatedARH = this.storageService.addAttributeToJsonObject('clientId ', clientId, aRHeaderJson);
            updatedARH = this.storageService.addAttributeToJsonObject('channelRequestData', '', aRHeaderJson);
            this.domStorageFB.setItem('alightRequestHeader', JSON.stringify(updatedARH));
        }
    }

    /**
      * Function for validation of clientId attribute in alightRequestHeader for support preauth/postauth api call for D&M service.
      * Argument alightRequestHeader any
      */
    /* istanbul ignore next */
    private validateClientIdAttribute(alightRequestHeader: any) {
        let attributeName = 'clientId';
        if (alightRequestHeader) {
            if (!alightRequestHeader[attributeName]) {
                try {
                    let clientId = this.domStorageFB.getItem('clientIdValue');
                    if (clientId && (clientId !== 'null') && (clientId !== '')) {
                        alightRequestHeader[attributeName] = clientId;
                        return alightRequestHeader;
                    } else {
                        if (LoggingService.uConsole) {
                            console.log('Valid clientId is not available in storage=>validateClientIdAttribute()');
                        }
                    }
                } catch (error) {
                    if (LoggingService.uConsole) {
                        console.log('Error occurred while setting clientId attrbute in alightRequestHeader=>validateClientIdAttribute() ', error);
                    }
                }
            }
        }
        return alightRequestHeader;
    }

    /* istanbul ignore next */
    public getOrgName() {
        try {
            return window.location.href.split('/web/')[1].split('/')[0];
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error occurred while getting orgname ', error);
            }
        }
    }

    /**
    * Method to invalidate user session.
    * requestType?: string, urlOptions?: IUrlOptions, body?: any, key?: string
    */

    /* istanbul ignore next */
    public endSessionForPerson() {

        let isSessionAPIEnabled = this.domStorageFB.getItem('enableSessionAPI', '', true);

        if (LoggingService.uConsole) {
            console.log('RemoteService.endSessionForPerson method Starting end session process :: ', isSessionAPIEnabled);
        }

        if (isSessionAPIEnabled && isSessionAPIEnabled === 'true' && this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true))) {
            this.request('post', {
                restOfUrl: '',
                endPoint: 'session/endSessionForPerson',
                isSecure: true,
                contentType: 'application/json'
            }, {}).subscribe((res: Response) => {
                if (LoggingService.uConsole) { console.log('RemoteService.endSessionForPerson: endSessionForPerson executed successfully', res); }
            });
        }
    }

    /* istanbul ignore next */
    public clearAll_IDBStores_SW() {
        this.localCacheService.clear_ALLIDBStores_SW();
    }

    /* istanbul ignore next */
    public formatDate() {
        let d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [year, month, day].join('-');
    }

}


